<template lang="pug">
  vm-prompt(:vm-buttons-hidden="true" vm-size="large" @vm-cancel="close" @vm-close="close" :vm-active="isModalSummaryVisible" vm-title='Resúmen de Orden')
    .model-section
      vm-row(class="section-summary" vm-w="12")
        vm-col(class="section-summary__text" vm-w=8)
          span {{form.folio}}
          p {{ $t('purchase_orders.information') }}
        vm-col(class="section-summary__buttons" vm-type="flex" vm-align="flex-end" vm-justify="end" vm-w=4)
          vm-button(@click="printPurchase(form.id)" class="button_white" icon="file-add-outline" ) {{ $t('purchase_orders.download_pdf')  }}
      vm-row(vm-align="center" vm-type="flex" vm-w=12 class="section-custom")
        vm-col(vm-type="flex" vm-align="center" vm-lg=8 vm-sm=12)
          .section-custom__icon
            vm-icon(icon="clipboard-outline" size="1rem")
          span {{ $t('quotations.master_data') }}
        vm-row(vm-align="center" vm-type="flex" vm-w=12 class="section-custom")
          vm-col(vm-type="flex" vm-lg=4 vm-sm=4 class="section-custom__inputs")
            span {{ $t('purchase_orders.folio') }}:
            p {{form.folio}}
          vm-col(vm-type="flex" vm-lg=4 vm-sm=4 class="section-custom__inputs")
            span {{ $t('purchase_orders.supplier_display') }}
            p {{ form.supplier.name }}
          vm-col(vm-type="flex" vm-lg=4 vm-sm=4 class="section-custom__inputs")
            span {{ $t('purchase_orders.shipping_address') }}
            p {{ form.shipping_address }}
          vm-col(vm-type="flex" vm-lg=4 vm-sm=4 class="section-custom__inputs")
            span {{ $t('purchase_orders.created_at') }}
            p {{ form.created_at | moment("DD MMMM YYYY")}}
          vm-col(vm-type="flex" vm-lg=4 vm-sm=4 class="section-custom__inputs")
            span {{ $t('purchase_orders.delivery_time') }}
            p {{ form.delivery_time }}
          vm-col(vm-type="flex" vm-lg=4 vm-sm=4 class="section-custom__inputs")
            span {{ $t('purchase_orders.freight') }}
            p {{ Boolean(form.freight) ? 'Si' : 'No' }}
      vm-row(vm-align="center" vm-type="flex" vm-justify="space-around" vm-w=12 class="section-custom")
        vm-col(vm-type="flex" vm-align="center" vm-lg=12 vm-sm=12)
          .section-custom__icon
            vm-icon(icon="search-outline" size="1rem")
          span {{ $t('quotations.details_data') }}
        vm-row.table_products(vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=12)
            vm-table(max-height="350px" max-items="10" pagination :data="form.details" )
              template(slot="thead")
                vm-th(:key="index" v-for="(column, index) in columns") {{ $t('requisitions_mailboxes.' + column) }}
              template(slot-scope="{data}")
                vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                  vm-td(:data="data[indextr][column]" :key="index" v-for="(column, index) in columns")
                    slot(v-if="column == 'total' || column == 'unit_price'")  {{data[indextr][column] | currency }}
                    slot(v-if="column == 'created_at'")  {{data[indextr][column] | moment("DD MMMM YYYY") }}
                    slot(v-if="column == 'supply'")  {{ data[indextr][column]['sku'] }}
                    slot(v-if="column != 'status' && column != 'remaining' && column != 'supply' && column != 'created_at' && column != 'name' && column != 'name' && column != 'role' && column != 'total' && column != 'unit_price'") {{data[indextr][column]}}
            transition(name="enter")
              .total-products(v-if="form.total_products > 0") Total de productos: {{ form.total_products }}
        vm-row(vm-align="center" vm-type="flex" vm-justify="space-around" vm-w=12 class="section-custom")
          vm-col(vm-type="flex" vm-align="center" vm-lg=12 vm-sm=12)
            .section-custom__icon
              vm-icon(icon="file-add-outline" size="1rem")
            span {{ $t('quotations.extra_information') }}
          vm-row(vm-align="center" vm-type="flex" vm-w=12 class="section-custom")
            vm-col(vm-type="flex" vm-lg=12 class="section-custom__inputs")
              span {{$t('quotations.attached_file')}}
              div(class="section-custom__card__grid"  v-if="form.file_name != null")
                div(class="section-custom__card__grid__item" @click="openViewer(form)")
                  header
                    img(:src='checkFormat(form.file_name)')
                    span {{ getFileNameFormated(form.file_name) }}
          vm-row(vm-align="center" vm-type="flex" vm-w=12 class="section-custom")
            vm-col(vm-type="flex" vm-lg=8 vm-sm=8 class="section-custom__inputs")
              span {{$t('quotations.notes')}}
              p(class="section-custom__inputs__notes-info") {{ form.notes }}
            vm-col(vm-type="flex" vm-lg=4 vm-sm=4 class="section-custom__inputs-totals")
              span {{$t('quotations.totals')}}: {{form.currency_id === 1 ? 'MXN' : 'USD'}}
              p(class="section-custom__inputs-totals__p") {{$t('quotations.subtotal')}}: {{ form.subtotal | currency }}
              p(class="section-custom__inputs-totals__p") {{$t('quotations.tax_amount')}}: {{ form.tax_amount | currency }}
              p(class="section-custom__inputs-totals__p") {{$t('purchase_orders.freight')}}: {{ form.total_freight | currency }}
              p(class="section-custom__inputs-totals__p") {{$t('quotations.total')}}: {{ form.total | currency }}
</template>
<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('PurchaseOrders')

export default {
  name: 'ModalSummaryOrder',
  mixins: [ModalMixin1],
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    columns: ['id', 'supply', 'supply_unit', 'supply_pending_quantity', 'unit_price', 'total']
  }),
  computed: {
    ...mapGetters(['isModalSummaryVisible'])
  },
  async created () {
  },
  methods: {
    ...mapActions([
      'setModalSummaryVisible',
      'printPurchase',
      'openFile'
    ]),
    getFileNameFormated (file) {
      return file.replace(/\.[^/.]+$/, '')
    },
    checkFormat (file) {
      const type = file.split('.').pop()
      switch (type) {
        case 'dwg':
        case 'dxf':
          return require('@/assets/icons/auto.png')
        case 'xls':
        case 'spread':
        case 'xlsx':
        case 'csv':
          return require('@/assets/icons/excel.svg')
        default:
          return require('@/assets/icons/pdf.svg')
      }
    },
    openViewer (record) {
      this.openFile(record.file_url)
    },
    close () {
      this.setModalSummaryVisible(false)
    }
  }
}
</script>
<style lang="scss" scoped>
.model-section
{
  max-height:600px;
  overflow-y: scroll;
}
.section-summary {
  &__text {
    display: flex;
    flex-direction: column;
    p {
      font-size: 16px;
      color: #696969;
    }
  }
  &__buttons {
    display: flex;
    justify-content: right;
    .vm-button {
      background-color: white !important;
      color: black !important;
      display: flex;
      border: 1px solid black;
      margin: 5px;
    }
  }
}
.section-custom {
  margin: 20px 0;
  &__icon {
    margin-right: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    padding: 14px;
    border: 1px solid rgba($color: var(--gray), $alpha: 1.0);
    background-color: #F2F4F7;
    color: rgba($color: var(--primary), $alpha: 1.0);
  }
  &__inputs {
    margin-top: 10px;
    flex-direction: column;
    &__notes-info {
      white-space: pre-line;
    }
    span {
       font-weight: 700;
      font-size: 12px;
      color: #8A8A8A;
    }
    p {
      font-weight: 400px;
      font-size: 14px;
    }
  }
  &__inputs-totals {
    flex-direction: column;
    background-color: #E0E0E0;
    border: 1px solid rgba($color: var(--primary), $alpha: 1.0);
    border-radius: 10px;
    padding: 20px 30px;
    width: calc(100% - 60px);
    span {
      font-weight: bold;
      font-size: 14px;
      color: rgba($color: var(--primary), $alpha: 1.0);
    }
    p {
      font-weight: 400px;
      font-size: 14px;
      color: black;
      margin: 8px 30px;
    }
  }
  span {
    font-weight: 600;
  }
  &__ul {
    display: flex;
    flex-wrap: wrap;
    font-size: 12px;
    margin: 10px;
    color: #8A8A8A;
    & li {
      margin-right: 22px;
    }
  }
  &__card {
    &__grid {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      grid-gap: 20px;
      &__item {
        &__dropdown {
          position: absolute;
          top: 0;
          right: 0;
        }
        & header {
          padding: 10px;
          display: flex;
          justify-content: start;
          & img {
            width: 25px;
            margin-right: 10px;
            cursor: pointer;
          }
        }
      }
    }
  }
}

.table_products {
  background-color: #F2F4F7;
  margin-top: 20px;
  .vm-table--tbody-table .tr-table tr {
    background-color: #F2F4F7 !important;
  }
  .vm-table--thead-table th {
    background-color: #E0E0E0 !important;
  }
  .vm-table--thead-table th.td-check {
    background-color: #E0E0E0 !important;
  }
}
</style>
